/**
 * The one way an email address is compared or stored.
 *
 * Addresses arrive from typed forms, CSV imports and sign-in links, so their
 * casing and surrounding whitespace are whatever the sender happened to send.
 * Firestore's `==` is exact, so an address stored one way and queried another
 * simply does not match — and a missed match here does not look like a failed
 * lookup, it looks like "no such user". `organizations.checkUserExists` queried
 * the raw address while user creation lowercased it, so adding an existing user
 * whose address had a capital letter took the create path and died in the
 * callable with `already-exists`.
 *
 * Use this on both sides of every comparison, and before every write.
 */
export function normalizeEmail(email: string): string {
	return email.trim().toLowerCase();
}
